import { timestampInSeconds as a } from "./chunk889.js";
import { uuid4 as u } from "./chunk890.js";
function p(d, r = {}) {
  if (r.user && (!d.ipAddress && r.user.ip_address && (d.ipAddress = r.user.ip_address), !d.did && !r.did && (d.did = r.user.id || r.user.email || r.user.username)), d.timestamp = r.timestamp || a(), r.abnormal_mechanism && (d.abnormal_mechanism = r.abnormal_mechanism), r.ignoreDuration && (d.ignoreDuration = r.ignoreDuration), r.sid && (d.sid = r.sid.length === 32 ? r.sid : u()), r.init !== void 0 && (d.init = r.init), !d.did && r.did && (d.did = `${r.did}`), typeof r.started == "number" && (d.started = r.started), d.ignoreDuration)
    d.duration = void 0;
  else if (typeof r.duration == "number")
    d.duration = r.duration;
  else {
    const i = d.timestamp - d.started;
    d.duration = i >= 0 ? i : 0;
  }
  r.release && (d.release = r.release), r.environment && (d.environment = r.environment), !d.ipAddress && r.ipAddress && (d.ipAddress = r.ipAddress), !d.userAgent && r.userAgent && (d.userAgent = r.userAgent), typeof r.errors == "number" && (d.errors = r.errors), r.status && (d.status = r.status);
}
export {
  p as updateSession
};
